import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { IRuntimeSourceCodeProcess, RuntimeSourceCodeProcess, RuntimeSourceCodeProcessPropertyValues } from "./RuntimeSourceCodeProcess";
import { NAMESPACE } from "./_Namespace";

export type RuntimeUsingDirectivesProcessPropertyValues =
    RuntimeSourceCodeProcessPropertyValues
    & {
    };

export type RuntimeUsingDirectivesProcessProperties = {
    [name in keyof RuntimeUsingDirectivesProcessPropertyValues]: Property<RuntimeUsingDirectivesProcessPropertyValues[name]>
};

export interface IRuntimeUsingDirectivesProcess extends IRuntimeSourceCodeProcess, RuntimeUsingDirectivesProcessProperties
{
}

export class RuntimeUsingDirectivesProcess extends RuntimeSourceCodeProcess implements IRuntimeUsingDirectivesProcess
{
    // #region Static

    public static override classNamespace = NAMESPACE + "RuntimeUsingDirectivesProcess";
    public static override className = "RuntimeUsingDirectivesProcess";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<RuntimeUsingDirectivesProcessPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<RuntimeUsingDirectivesProcessPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _createElementComplete()
    {
        super._createElementComplete();

        this.addCssClass("rad-control-runtime-using-directives-process");
    }

    // #endregion

    // #endregion
}

